<template>
  <div class="briefly">
    <div class="left">
      <div class="briefly-row">
         <div class="title">
          <span class="num">01</span>
          <span>概况</span>
        </div>
        <div class="content">
          <div class="content-recommend">
            <p ref="p1">上海鑫达实业（集团）有限公司（以下简称：鑫达集团）是新泾经济联合社所属新泾镇级集体经济组织，成立于1992年，注册资本19000万元，经营范围：实业投资，自有房屋租赁，物业管理，停车场（库）经营管理，投资管理，投资咨询，国内贸易（除专项规定）。</p>
            <p ref="p2">鑫达集团本部位于虹桥商务区核心区长宁区新泾镇域内，地处虹桥临空经济园区，北横通道北翟路地下通道入口处，虹桥交通枢纽与虹桥商务中心与之零距离，古北经济开发区近在咫尺，地理位置得天独厚。</p>
            <p ref="p3">鑫达集团全资子公司有：上海绿谷别墅管理有限公司、上海新泾房地产开发有限公司、上海鑫达会务服务有限公司、上海茂星实业有限公司、上海善鑫老年服务有限公司、上海鑫兆企业服务有限公司、上海天益实业有限公司等。鑫达集团控股公司：上海兴程实业合作公司、上海鑫光企业发展有限公司、上海荣茂工贸有限公司。</p>
            <p ref="p4">鑫达集团及其全资子公司、控股公司主要从事楼宇经济，自有商务楼建筑面积共37.6万㎡，其中鑫达集团本部楼宇面积23.6万㎡，三家全资子公司和三家控股公司房屋总面积14万㎡，鑫达集团占所有集体房屋面积62%。 镇域内集体土地面积257亩，其中绿谷别墅206亩（178幢别墅 ）。鑫达集团及其下属子公司持有上海虹康房产建设有限公司49%股权，在宁波也有投资项目。</p>
            <p ref="p5">从上述商务楼宇的分布地域看，将近31万㎡楼宇分布在三个区，东到长宁区古北路，西至青浦区赵巷镇，南处闵行区七宝镇，北抵长宁区临空经济园区，其中临空经济园区内有11幢楼宇共8.5万多㎡。</p>
          </div>
          <div class="right" ref="right" :style="{'height': heightNum + 'px'}">
            <img src="@/assets/images/gateway/park/_MG_8643.jpg"/>
          </div>
        </div>
        <p>鑫达实业秉持“5公里高净值投资圈，30公里高质量发展圈，0公里高品质生活圈” 的发展方针，积极寻找收储优质企业楼宇，以“资金变资产，资产变收益”为集体企业发展方向，先后投资建造或出资收购了鑫达大厦、鑫达广场A座、B座、鑫达财富中心、鑫达科研楼、虹桥中央大厦、虹桥国际科技广场D幢、鑫达产业园、茂星广场、铭辉商务楼、善鑫大楼、海益商务楼等多幢商务办公楼宇。</p>
      </div>
      <div class="briefly-row">
        <div class="title">
          <span class="num">02</span>
          <span>经营宗旨</span>
        </div>
        <p>鑫达集团以“稳健、高效、持续、创新、共享”的发展理念，坚持守土有责，守土尽责，砥砺前行抓生产、一心一意谋发展，促进集体经济做大、做强、做优，确保集体资产保值增值。</p>
      </div>
      <!-- <div class="briefly-row">
        <div class="title">
          <span class="num">02</span>
          <span>经营宗旨</span>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      heightNum: 0
    }
  },
  mounted() {
    this.heightNum = this.$refs.p1.offsetHeight + this.$refs.p2.offsetHeight + this.$refs.p3.offsetHeight + this.$refs.p4.offsetHeight + this.$refs.p5.offsetHeight
  }
}
</script>
<style lang="scss" scoped>
.briefly {
  padding: 0 10%;
  box-sizing: border-box;
  .left {
    .briefly-row {
      .title {
        font-size: 0.3rem;
        font-weight: bold;
        font-family: Source Han Sans CN;
        color: #333333;
        line-height: 0.5rem;
        .num {
          font-family: D-DIN Exp;
          color: #E79E2A;
          margin-right: 0.15rem;
        }
      }
      .content{
        display: flex;
        .content-recommend{
          width: 11rem;
        }
      }
      p {
        font-size: 0.14rem;
        line-height: 0.25rem;
        margin-bottom: 0.2rem;
      }
    }
  }
  .right {
    width: 11rem;
    // height: 370px;
    margin-left: 0.5rem;
    border: 0.3rem solid #EAECF1;
    border-right: none;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>